import React from 'react';
import { FeedbackRequestCount, FinderInfo, FinderSearchWrapper, FinderWrapper } from './finder-feedback-request.styles';
import { FinderFeedbackRequestProps } from './types';
import { Button } from '@vtbhome/juicyfront';
import { useFeedbackRequestListSharedQuery } from '@entities/feedback-request/libs/hooks/use-feedback-request-list-shared-query/use-feedback-request-list-shared-query';
import { Typography } from '@shared/ui/typography/typography';
import { ArrowsArrowRight } from '@vtbhome/juicyfront/indexIcon';
import { ROUTE_ADMIN_APPEALS } from '@shared/config/routes/routes';
import { useRedirect } from '@shared/lib/hooks/use-redirect/use-redirect';
import { Search } from '@shared/ui/search/search';

export const FinderFeedbackRequest: React.FC<FinderFeedbackRequestProps> = ({
    feedbackRequestsListParameters,
    setFeedbackRequestsListParameters,
}) => {
    const redirect = useRedirect();
    const [, getFeedbackRequestsListResult] = useFeedbackRequestListSharedQuery(feedbackRequestsListParameters);

    return (
        <FinderWrapper>
            <FinderInfo>
                <Typography size='h6'>Обращения</Typography>
                <FeedbackRequestCount>
                    <Typography size='body2_long'>{getFeedbackRequestsListResult.data?.total || 0}</Typography>
                </FeedbackRequestCount>
            </FinderInfo>
            <FinderSearchWrapper>
                <Search
                    parameters={feedbackRequestsListParameters}
                    placeholder='Поиск'
                    setParameters={setFeedbackRequestsListParameters}
                />
                <Button
                    round
                    size='m'
                    buttonType='secondary'
                    startAdornment={<ArrowsArrowRight />}
                    onClick={() =>
                        redirect({
                            url: ROUTE_ADMIN_APPEALS,
                            state: {
                                search: feedbackRequestsListParameters.search || undefined,
                            },
                        })
                    }
                />
            </FinderSearchWrapper>
        </FinderWrapper>
    );
};
